export const environment = {
  production: false,
  ApiConecta: 'https://api.co.test.bayport-digital.com/v1/agents/',
  ApiPortal: 'https://clientsettings.co.prod.bayport-digital.com/portal-agentes',
  ApiConectaDocker:'https://api.satelitales.col.test.bayport-digital.com/agents/',
  ApiDocumentExtractor: 'https://api.satelitales.dev.bayport-digital.com/v1/gateway-documents/api/v1/gateway-documents/documents-extractor/',
  APITESTPROFILE: 'https://api.co.dev.bayport-digital.com/v1/agents/unified-profile',

  Apiwhatsapp: 'https://api.satelitales.test.bayport-digital.com/v1/whatsapp/api/v1/api-whatsapp/whatsapp/message',
  ApiWhatsappValidate: 'https://api.satelitales.test.bayport-digital.com/v1/whatsapp/api/v1/api-whatsapp/whatsapp/validate',


};
